import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Flex, Box } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from 'generated/graphql';

import { ParagraphSmall } from '../../../../kakapo-ui-kit/components/common/Paragraph';
import DeleteButton from '../../../../kakapo-ui-kit/components/editors/DeleteButton';
import Select from '../../../../kakapo-ui-kit/components/forms/controls/Select';

interface IOption {
	label: string;
	value: string;
}

const MomentTemplateVariationElement = styled(Flex)`
	background-color: ${(props) => props.theme.colors.whiteBlue};
	border-radius: 4px;
`;

const MomentTemplateVariation = ({
	templates,
	jobTitles,
	name,
	onRemove,
}: {
	templates: IOption[];
	jobTitles: IOption[];
	name: string;
	onRemove: () => void;
}) => {
	const { t } = useTranslation();
	const [{ value: variation }, , helpers] = useField<graphql.MomentVariation>(name);

	const selectedTemplateID = variation.evaluation!.evaluationForm!.id;
	const selectedTemplate = templates.find((template) => template.value === selectedTemplateID);

	const selectedJobTitleID = variation.jobTitle.id;
	const selectedJobTitle = jobTitles.find((jobTitle) => jobTitle.value === selectedJobTitleID);

	return (
		<MomentTemplateVariationElement alignItems="center" px={3} py={3} mb={2}>
			<Box width={5 / 12} mr={2}>
				<ParagraphSmall color="lightBlueDark">
					{t('common.settings.momentTemplates.variations.evaluationTemplate')}
				</ParagraphSmall>

				<Select
					unspaced
					small
					value={selectedTemplate}
					options={templates}
					onChange={(value) => {
						if (!value) {
							return;
						}

						helpers.setValue({
							...variation,
							evaluation: {
								evaluationForm: ({
									id: value.value,
								} as unknown) as graphql.EvaluationForm,
							},
						});
					}}
				/>
			</Box>

			<Box width={5 / 12} mr={3}>
				<ParagraphSmall color="lightBlueDark">
					{t('common.settings.momentTemplates.variations.jobTitle')}
				</ParagraphSmall>

				<Select
					unspaced
					small
					value={selectedJobTitle}
					options={jobTitles}
					onChange={(value) => {
						if (!value) {
							return;
						}

						helpers.setValue({
							...variation,
							jobTitle: ({
								id: value.value,
							} as unknown) as graphql.JobTitle,
						});
					}}
				/>
			</Box>

			<Flex width={2 / 12} justifyContent="flex-end">
				<DeleteButton onClick={() => onRemove()} />
			</Flex>
		</MomentTemplateVariationElement>
	);
};

export default MomentTemplateVariation;
